import { all, fork } from 'redux-saga/effects'
import pollSagaWatch from './polling'
import watchWatchSkin from './design'

export default function* rootSaga() {
  yield all([fork(pollSagaWatch), fork(watchWatchSkin)])
}
